import { getApiClient } from '@plandi/common'
import { components } from '@plandi/common/src/generated'

export const commonApi = {
  getAdvertisementData: (locale: string) =>
    getApiClient(locale)
      .get<[components['schemas']['AdvertisingResource']]>('v1/content/other')
      .then(({ data }) => data[0].data),

  getMyProfileCompany: (locale: string) =>
    getApiClient(locale)
      .get<{
        data: components['schemas']['ProfileCompanyMeResource']
      }>('v1/profiles/companies/me')
      .then(({ data }) => data.data),

  getMyProfileFactory: (locale: string) =>
    getApiClient(locale)
      .get<{
        data: components['schemas']['ProfileFactoryMeResource']
      }>('v1/profiles/plants/me')
      .then(({ data }) => data.data),

  getMyProfileFreelancer: (locale: string) =>
    getApiClient(locale)
      .get<{ data: components['schemas']['ProfileSpecialistMeResource'] }>(
        'v1/profiles/specialists/me?type=freelancer'
      )
      .then(({ data }) => data.data),

  getProfileReviews: (profileId: number, locale: string) =>
    getApiClient(locale)
      .get<components['schemas']['ReviewListResourse']>(
        `v1/profiles/review/${profileId}`
      )
      .then(({ data }) => data)
}
